import React from 'react'
import { Row, Col, Stencil, Spacer } from '@cleartrip/bento'

import { Picture } from '@cleartrip/bento-icons'
function TopDestinationsLoading() {
    return (
        <Row>
            <Col span={4}>
                <div className="br-4 o-hidden">
                    <Stencil height={178} width="100%" shimmer={true} className="flex flex-middle flex-center">
                        <Picture height={40} width={40} className="c-neutral-300" />
                    </Stencil>
                </div>
                <Spacer className="pt-2" />
                <Stencil shimmer height={20} width={150} />
                <Spacer className="pt-1" />
                <Stencil shimmer height={16} width={100} />
            </Col>
            <Col span={4}>
                <div className="br-4 o-hidden">
                    <Stencil height={178} width="100%" shimmer={true} className="flex flex-middle flex-center">
                        <Picture height={40} width={40} className="c-neutral-300" />
                    </Stencil>
                </div>
                <Spacer className="pt-2" />
                <Stencil shimmer height={20} width={150} />
                <Spacer className="pt-1" />
                <Stencil shimmer height={16} width={100} />
            </Col>
            <Col span={4}>
                <div className="br-4 o-hidden">
                    <Stencil height={178} width="100%" shimmer={true} className="flex flex-middle flex-center">
                        <Picture height={40} width={40} className="c-neutral-300" />
                    </Stencil>
                </div>
                <Spacer className="pt-2" />
                <Stencil shimmer height={20} width={150} />
                <Spacer className="pt-1" />
                <Stencil shimmer height={16} width={100} />
            </Col>
            <Col span={4}>
                <div className="br-4 o-hidden">
                    <Stencil height={178} width="100%" shimmer={true} className="flex flex-middle flex-center">
                        <Picture height={40} width={40} className="c-neutral-300" />
                    </Stencil>
                </div>
                <Spacer className="pt-2" />
                <Stencil shimmer height={20} width={150} />
                <Spacer className="pt-1" />
                <Stencil shimmer height={16} width={100} />
            </Col>
            <Col span={4}>
                <div className="br-4 o-hidden">
                    <Stencil height={178} width="100%" shimmer={true} className="flex flex-middle flex-center">
                        <Picture height={40} width={40} className="c-neutral-300" />
                    </Stencil>
                </div>
                <Spacer className="pt-2" />
                <Stencil shimmer height={20} width={150} />
                <Spacer className="pt-1" />
                <Stencil shimmer height={16} width={100} />
            </Col>
            <Col span={4}>
                <div className="br-4 o-hidden">
                    <Stencil height={178} width="100%" shimmer={true} className="flex flex-middle flex-center">
                        <Picture height={40} width={40} className="c-neutral-300" />
                    </Stencil>
                </div>
                <Spacer className="pt-2" />
                <Stencil shimmer height={20} width={150} />
                <Spacer className="pt-1" />
                <Stencil shimmer height={16} width={100} />
            </Col>
        </Row>
    )
}

export default TopDestinationsLoading
